import s from '../allservices.jsx'

const getPasswordService = (actionCallback,userid) => {
    // const cardNumber = localStorage.getItem("cardNumber")
    fetch(s.get_password + "/" + userid + "/gmcabs" , {
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            } else {
                // console.log(res.headers.get('message'))
                actionCallback(res.headers.get('message'),"error")
            }
        })
}

export default getPasswordService;


// WEBPACK FOOTER //
// ./src/services/components/get_password.jsx